// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import type { IProps } from '@components/Paragraphs/ParagraphInfoBox/ParagraphInfoBox';
import { getFragmentData } from '@generated/fragment-masking';
import styles from './ParagraphInfoBox.module.sass';
// #endregion Local Imports

export const ParagraphInfoBoxFragment = gql(/* GraphQL */ `
  fragment ParagraphInfoBoxFragment on ParagraphInfoBox {
    infoBoxTitle: fieldTitle
    infoBoxText: fieldText {
      format
      processed
    }
  }
`);

export const ParagraphInfoBox: React.FunctionComponent<
  IProps.ParagraphInfoBox
> = ({ paragraph: _paragraph }) => {
  const paragraph = getFragmentData(ParagraphInfoBoxFragment, _paragraph);
  return (
    <div className={styles.ParagraphInfoBox__root}>
      <div className={styles.ParagraphInfoBox__box}>
        <div className={styles.ParagraphInfoBox__inner}>
          <h3>{paragraph.infoBoxTitle}</h3>
          <div
            dangerouslySetInnerHTML={{
              __html: String(paragraph.infoBoxText?.processed),
            }}
          />
        </div>
      </div>
    </div>
  );
};
